import TopPropertiesGridTwo from '../components/TopPropertiesGridTwo'
import Video from '../components/Video'
import mobile from '../assets/videos/topMobile.mp4'
import desktop from '../assets/videos/topPropertyDesktop.mp4'
import mobilePoster from '../assets/videos/topMobPoster.avif'
import desktopPoster from '../assets/videos/topDeskPoster.avif'
import { useTranslation } from 'react-i18next'

export default function TopProperties() {
  const { t } = useTranslation()
  return (
    <div>
      <section>
        <Video
          mobile={mobile}
          desktop={desktop}
          mobilePoster={mobilePoster}
          desktopPoster={desktopPoster}
          title={t('topOffersVideo.title')}
          subTitle={t('topOffersVideo.subTitle')}
          link={'#topPropertiesGrid'}
        />
      </section>
      <TopPropertiesGridTwo id='topPropertiesGrid' />
    </div>
  )
}
